import { Suspense } from "react";
import { Navigate } from "react-router-dom";
import { Layout } from "antd";
import SiteHeader from "../components/header";
import Can from "../services/permisions/Can";
import RolesHelper from "../services/permisions/RolesHelper";

const { Content } = Layout;

/* Main Layout */
const MainLayout = ({ children }) => (
	<Layout className="tb--h100 tb--projects">
		<SiteHeader />
		<Layout>
			<Layout>
				<Content>{children}</Content>
			</Layout>
		</Layout>
	</Layout>
);

/*
  Private route wrapper for React Router v6
 */

export const MainLayoutRoute = ({ component: Component, permissions, ...rest }) => {
	if (RolesHelper.isAffilateUser()) {
		return <Navigate to={RolesHelper.getRedirectPage()} replace />;
	}

	const content = (
		<MainLayout>
			<Suspense fallback={null}>
				<Component {...rest} />
			</Suspense>
		</MainLayout>
	);

	if (!permissions) {
		return content;
	}

	return (
		<Can I={permissions.type} a={permissions.name} withRedirect>
			{content}
		</Can>
	);
};
